export default __webpack_public_path__ + "static/media/img-hospital-location.d25b47e6.png";